import {Component} from '@angular/core';

@Component({
    selector: 'ui-loading',
    template: '<ui-spinner></ui-spinner>',
    styleUrls: ['loading.component.scss']
})
export class UILoadingComponent {
}